import FooterControl from '@/components/FooterControl.vue';
import { cloneDeep } from 'lodash';

export default {
  name: 'add-role',
  components: { FooterControl },
  data() {
    return {
      title: '新增',
      checkedNodes: [],
      state: this.$route.query.state || '',
      ztree: [], // 菜单
      expandKeys: [], // 菜单默认展开项
      defaultProps: {
        children: 'childNode',
        label: 'name',
      },
      ruleForm: {
        name: '',
        // statu: 1,
      },
      rules: { // 表单校验规则
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    if (this.state === 'edit') {
      this.title = '编辑';
      this.getData();
    } else if (this.state === 'check') {
      this.title = '查看';
      this.getData();
    } else {
      this.getZtree();
    }
  },
  methods: {
    goback() {
      this.$router.push({ name: 'personnel' });
    },
    getZtree() {
      this.$api.global.treeList().then((res) => {
        this.ztree = cloneDeep(res.childNode);
        // console.log("childNode："+this.ztree);
        this.expandKeys = res.childNode.map(item => item.id);
        let a = '';
        let b = '';
        this.ztree.forEach((item, index) => {
          item.childNode.forEach((it, i) => {
            // 剔除人员管理
            if (it.id === 37) {
              a = index;
              b = i;
            }
          });
        });
        if (a !== '' && b !== '') {
          this.ztree[a].childNode.splice(b, 1);
        }
      });
    },
    getData() {
      this.$api.clinicManagement.getRole({
        roleId: this.$route.query.roleId,
      }).then((res) => {
        this.ruleForm.name = res.name;
        // this.ruleForm.statu = res.statu || '';
        this.ztree = cloneDeep(res.permission.childNode);
        this.expandKeys = res.permission.childNode.map(item => item.id);
        console.log(this.ztree);
        let a = '';
        let b = '';
        if (this.state === 'edit') {
          this.ztree.forEach((item, index) => {
            item.childNode.forEach((it, i) => {
              if (it.checked === true) {
                this.checkedNodes.push(it.id);
              }
              // 剔除人员管理
              if (it.id === 37) {
                a = index;
                b = i;
              }
            });
          });
        } else {
          this.ztree.forEach((item, index) => {
            item.disabled = true;
            item.childNode.forEach((it, i) => {
              if (it.checked === true) {
                this.checkedNodes.push(it.id);
              }
              // 剔除人员管理
              if (it.id === 37) {
                a = index;
                b = i;
              }
              it.disabled = true;
            });
          });
        }
        if (a !== '' && b !== '') {
          this.ztree[a].childNode.splice(b, 1);
        }
        console.log(this.checkedNodes);
        this.setCheckedKeys();
      });
    },
    setCheckedKeys() {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedNodes);
      });
    },
    // 编辑角色
    editRole() {
      const checkedNodesHalf = this.$refs.tree.getHalfCheckedKeys() || []; // 目前半选中的节点的 key 所组成的数组
      const checkedNodes = this.$refs.tree.getCheckedKeys() || []; // 目前被选中的节点的 key 所组成的数组
      const allNodes = [...checkedNodesHalf, ...checkedNodes];
      this.$api.clinicManagement.updateRoleAndPermission({
        id: this.$route.query.roleId,
        ...this.ruleForm,
        permissionIds: allNodes.join(','),
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存成功！',
        });
        this.goback();
      });
    },
    // 添加角色
    addRole() {
      const checkedNodesHalf = this.$refs.tree.getHalfCheckedKeys() || []; // 目前半选中的节点的 key 所组成的数组
      const checkedNodes = this.$refs.tree.getCheckedKeys() || []; // 目前被选中的节点的 key 所组成的数组
      const allNodes = [...checkedNodesHalf, ...checkedNodes];
      this.$api.clinicManagement.insertRoleAndPermission({
        ...this.ruleForm,
        permissionIds: allNodes.join(','),
      }).then(() => {
        this.$message({
          type: 'success',
          message: '添加成功！',
        });
        this.goback();
      });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.state === 'edit') {
            this.editRole();
          } else {
            this.addRole();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  watch: {

  },
};
